import { Controller } from "@hotwired/stimulus"

/**
 * Saves the voter-facing Choice Group label ("Group Prompt") as soon as the
 * administrator leaves the field, so the page needs no separate Save button.
 * (Pressing Enter already submits natively — Turbo intercepts that.)
 *
 * The response is a turbo-stream that replaces this component's frame with the
 * persisted value plus either validation errors or a "Saved" confirmation —
 * all rendering stays server-side.
 */
export default class extends Controller<HTMLElement> {
  save(): void {
    const form = this.element.querySelector("form") as HTMLFormElement | null
    if (!form) return

    form.requestSubmit()
  }
}
